import React from 'react';
import { compose } from 'ramda';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { OrganizationType } from 'store/modules/auth/auth';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import CustomerSatisfaction from './CustomerSatisfaction/CustomerSatisfaction';
import BrandValuatorReport from './BrandValuator/BrandValuator';
import DefaultReportV2 from './DefaultReports/DefaultReports';
import { withProject, WithProjectProps } from '../withProject';

const { connect, selectors } = StoreProvider;

interface ProjectReportsProps
  extends RouteComponentProps<{ id: string; codename: string }> {
  organization: OrganizationType;
  product: WithProjectProps['product'];
  project: WithProjectProps['project'];
}

const ProjectReports = ({
  product,
  match,
  project,
  organization,
}: ProjectReportsProps) => {
  const params = useParams<{ codename: string }>();
  const isCustomerSatisfactionReportType =
    product.report_template_slug === 'customer-satisfaction-report';

  const isBrandValuatorReport = product.report_template_slug === 'wt_report';
  const history = useHistory();

  if (isCustomerSatisfactionReportType) {
    return (
      <CustomerSatisfaction
        history={history}
        match={match}
        product={product}
        project={project}
        organization={params.codename || organization.codename}
      />
    );
  } else if (isBrandValuatorReport) {
    return (
      <BrandValuatorReport
        match={match}
        product={product}
        project={project}
        organization={params.codename || organization.codename}
      />
    );
  } else {
    return (
      <DefaultReportV2
        match={match}
        product={product}
        project={project}
        organization={params.codename || organization.codename}
      />
    );
  }
};
export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
  })),
  withMetaDescription({ title: 'Dashboard projects' }),
  withProject(({ match, organization }: ProjectReportsProps) => ({
    projectId: match.params.id,
    organizationCodename: match.params.codename || organization.codename,
  }))
)(ProjectReports);
